import { BirthDatePicker } from '@/_components/inputs/birth-date-picker'
import { CepInput } from '@/_components/inputs/cep-input'
import { CurrencyInput } from '@/_components/inputs/currency-input'
import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/_components/ui'

import { BRAZILIAN_STATES } from '@/features/_constants/brazilian-states'
import type { RowConfig } from '../_helpers/field-config'

interface ConfirmedValueInputProps {
  row: RowConfig
  value: string
  onChange: (value: string) => void
  disabled: boolean
  error?: string
}

export const ConfirmedValueInput = ({
  row,
  value,
  onChange,
  disabled,
  error,
}: ConfirmedValueInputProps) => {
  if (row.key === 'income') {
    return (
      <CurrencyInput
        value={value}
        onValueChange={({ value: next }) => onChange(next)}
        disabled={disabled}
        decimalScale={2}
        fixedDecimalScale
        className="h-10 border-brand-grayscale-5 bg-white text-sm font-medium text-brand-grayscale-11 tabular-nums focus-visible:ring-brand-green-primary-4"
      />
    )
  }

  if (row.key === 'birth_date') {
    return (
      <div className="space-y-1">
        <BirthDatePicker
          value={value}
          onChange={onChange}
          disabled={disabled}
          hasError={!!error}
          className="h-10 w-full border-brand-grayscale-5 bg-white text-sm font-medium text-brand-grayscale-11 tabular-nums focus-visible:ring-brand-green-primary-4"
        />
        {error && <p className="text-xs font-medium text-aux-red-danger-5">{error}</p>}
      </div>
    )
  }

  if (row.subField === 'postcode') {
    return (
      <CepInput
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="h-10 border-brand-grayscale-5 bg-white text-sm font-medium text-brand-grayscale-11 tabular-nums focus-visible:ring-brand-green-primary-4"
      />
    )
  }

  if (row.subField === 'subdivisionId') {
    return (
      <Select value={value || undefined} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className="h-10 border-brand-grayscale-5 bg-white text-sm font-medium text-brand-grayscale-11 focus-visible:ring-brand-green-primary-4">
          <SelectValue placeholder="Selecione o estado" />
        </SelectTrigger>
        <SelectContent>
          {BRAZILIAN_STATES.map((state) => (
            <SelectItem key={state.code} value={state.code}>
              {state.code}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )
  }

  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className="h-10 border-brand-grayscale-5 bg-white text-sm font-medium text-brand-grayscale-11 focus-visible:ring-brand-green-primary-4"
    />
  )
}
